module.exports = __webpack_public_path__ + "img/ZAP.143ca55d.svg";